import React from "react";
import Logo from "./Logo"
import Mains from "./Mains";
import Tasty from "./Tasty";
import Extras from "./Extras";
import packageInfo from '../data_en.json';
import cube_logo from "./cube-logo.png"
import { useNavigate } from "react-router-dom"

const English = () => {
        let navigate = useNavigate()
        return (
        <section className="body">
        <div class="body-bg"></div>
        <div className="menu">
            <Logo />
            <button className="filter-btn" onClick={() => navigate("/")}>EL</button>
            <button className="filter-btn" onClick={() => navigate("/en")}>EN</button>
            <Tasty type="BREAKFAST" meals={packageInfo.breakfast} />
            <Mains type="COFFEE" meals={packageInfo.coffee} />
            <aside className="aside">
            <Tasty type="EXTRAS" meals={packageInfo.extras} />
            <Extras type="MORE" items={packageInfo.more} />
            <Extras type="DRINKS" items={packageInfo.drinks} />
            <Tasty type="EXTRAS" meals={packageInfo.extras_} />
            <Tasty type="SOMETHING TASTY" meals={packageInfo.something_tasty} />
          </aside>
        </div>
        <p className="underline_end"></p>
            <div className="copyrights">
              <a href="https://www.cube-creations.com" target="_blank" rel="noreferrer">
                <img src={cube_logo} alt="cube-logo" className="cube-logo"/>
              </a>
                <h5>© 2025 Cube Creations. All rights reserved.</h5>
            </div>  
        </section>
        );
};
export default English; 